/**
 * API Configuration
 * 
 * Centralized location for API constants. 
 * Values are pulled from environment variables defined in .env
 */

const getApiBaseUrl = () => {
    const envUrl = import.meta.env.VITE_API_BASE_URL;

    // In production, we should prioritize the env variable.
    // In development (localhost), we fallback to the hardcoded production URL 
    // ONLY if the env variable is missing, to ensure the app works out of the box.
    if (envUrl) {
        return envUrl;
    }

    return 'https://diasporawise.com:4000';
};

export const API_BASE_URL = getApiBaseUrl();

export const API_CONFIG = {
    BASE_URL: API_BASE_URL,
    ENDPOINTS: {
        SOLAR_LEADS: '/admin/solar/leads',
        LOCATION_SEARCH: '/api/location/search',
        LOCATION_DETAILS: (id: string) => `/api/location/details/${id}`,
    }
};
